import { useState } from "react";
import "./App.css";
import Option1 from "./components/Option-1";
import Option2 from "./components/Option-2";
import logo from './vmw-ico-vmc-foundation-rgb_16px.svg';
import ReactGA from 'react-ga4';
import { CdsButton } from '@cds/react/button';

const tracking_ga4_id ="G-V3VSWJVPEE";

ReactGA.initialize(tracking_ga4_id);
ReactGA.send("pageview");

function App() {
  const [option, setOption] = useState(1);



  return (

      <div class="App">
					<header className="header">
						<div class="row">
              <div class="col">
								<img src={logo}  alt=""/>
								<span class="title">VMware Cloud Foundation - JSON Generator</span>
                <span class="subtitle"><a className="link" target="_blank" rel="noopener noreferrer" href="https://www.martingustafsson.com">martingustafsson.com</a></span>
              </div>

            </div>
					</header>

        <div className="SelectOption">
        <cds-button
          className={
            option === 1 ? "SelectedOptionButton" : "SelectOptionButton"
          }
          onClick={() => {
            setOption(1);
          }}
        >
          Deploy VI Workload Domain
        </cds-button>&nbsp;&nbsp;&nbsp;&nbsp;
        <cds-button
          className={
            option === 2 ? "SelectedOptionButton" : "SelectOptionButton"
          }
          onClick={() => {
            setOption(2);
          }}
        >
          Deploy Cluster
        </cds-button>&nbsp;&nbsp;&nbsp;&nbsp;

        <CdsButton
          onClick={() => { window.open('https://martingustafsson.com/vcf-ui-json', '_blank'); }}
        >
          VCF 5.x
        </CdsButton>
        </div>
        <div>{option && option === 1 ? <Option1 /> : <Option2 />}</div>
    </div>
  );
}



export default App;
